import { Component, TemplateRef } from '@angular/core';
import { ToastService } from 'src/app/core';

@Component({
  selector: 'eos-toast',
  templateUrl: './toast.component.html',
  host: { class: 'toast-container position-fixed w-100  top-0 start-0 p-3', style: 'z-index: 1200' }
})
export class ToastComponent {

  constructor(public toastService: ToastService) { }

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
  close(toast) {
    this.toastService.toasts.splice(this.toastService.toasts.indexOf(toast), 1);
  }


}
